const fr = {
  listTitle: 'Tous les workflows',
  addButton: 'Ajouter un workflow',
  lastUpdated: 'Last modified',
}

export default fr
